module.exports = __webpack_public_path__ + "img/c10.b50d30af.png";